import React, { useEffect, useRef, useState } from "react";
import { collection, onSnapshot, or, query, where } from "firebase/firestore";
import '@coreui/coreui/dist/css/coreui.min.css'
import { useLocation, useNavigate } from "react-router-dom";
import { ref, getDownloadURL } from "firebase/storage";
import db, { storage } from "../../firebase/firebaseConfig";
import { useMemo } from "react";
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useLoading } from "../Loading";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

const AdoptPet = () => {
  const [pets, setPets] = useState([]);
  const {setLoading} = useLoading();
  const malaysiaStates = [
    "Johor",
    "Kedah",
    "Kelantan",
    "Malacca",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Penang",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
    "Kuala Lumpur",
  ];
  const [isExpanded, setIsExpanded] = useState(false);
  const collapseRef = useRef(null);

  useEffect(() => {
    const collapseElement = collapseRef.current;
    if (collapseElement) {
      const collapseInstance = new window.coreui.Collapse(collapseElement, {
        toggle: false // Prevent automatic toggling by the button initially
      });

      if (isExpanded) {
        collapseInstance.show();
      } else {
        collapseInstance.hide();
      }
    }
  }, [isExpanded]);
  const handleButtonClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const fetchPets = async () => {
      const petCollection = query(collection(db, "Pets"), or( where("status","==","Pending"), where("status","==", "Available")));
      const unsubscribePet = onSnapshot(petCollection, (petSnapshot)=>{
        const petList = petSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPets(petList);
      }, (error)=>{
        console.log(error);
      });

     return ()=> unsubscribePet();
    };

    fetchPets();
  }, []);

  
  const navigate = useNavigate();
  const location = useLocation();
  const [filters, setFilters] = useState({
    petType: location?.state?.petType || "all",
    state: "all",
    age: "all",
    size: "all",
    gender: "all",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

//useMemo to prevent unnecessary re-computation.
  const filteredPets = useMemo(() => { 
    return pets.filter((pet) => {
      return (
        (filters.petType === "all" || pet.petType === filters.petType) &&
        (filters.state === "all" || pet.location === filters.state) &&
        (filters.age === "all" || pet.age === filters.age) &&
        (filters.size === "all" || pet.size === filters.size) &&
        (filters.gender === "all" || pet.gender === filters.gender)
      );
    });
  }, [pets, filters]);

  const [imageUrls, setImageUrls] = useState({});

useEffect(() => {
  const fetchImages = async () => {
    const urls = {};
    for (let pet of filteredPets) {
      try {
        const imageRef = ref(storage, `AdoptPets/${pet.image}`);
        const url = await getDownloadURL(imageRef);
        urls[pet.id] = url;
        // const image = await getPetImage(pet.image);

        // urls[pet.id] = image.urls;
      } catch (error) {
        console.error(`Error fetching image for petID ${pet.id}:`, error);
        urls[pet.id] = "/defaultImage.jpg"; // Fallback image
      }
    }
    setImageUrls((prev) => {
      const isDifferent = JSON.stringify(prev) !== JSON.stringify(urls);
      return isDifferent ? urls : prev; //avoid keep looping
    });
  };

  fetchImages();
  setLoading(false);
}, [filteredPets]); 

  const handleClearFilters= () => {
    setFilters({
      petType: "all",
      state:"all",
      age: "all",
      size: "all",
      gender: "all",
    })
  }

    const [activeStep, setActiveStep] = useState(0);
    const petsPerPage = 8;
    const maxSteps = Math.ceil(filteredPets.length / petsPerPage);
    const startIndex = activeStep * petsPerPage;
    const currentPets = filteredPets.slice(startIndex, startIndex + petsPerPage);
  
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

  return (
    <div className="petAdoptionContainer">
      
      <div className='filterContainer' style={{marginTop:"1%"}}>
        
        <div id="collapseExample" className={`collapse ${isExpanded ? 'show' : ''} filterList`} >

       
        <div>
          <label htmlFor="petType">Pet Types</label> <br></br>
          <select name="petType" id="petType" className="form-select form-select-sm" 
          aria-label="Default select example" value={filters.petType}
          onChange={handleFilterChange}>
            <option value="all">All</option>
            <option value="Dog">Dog</option>
            <option value="Cat">Cat</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div>
        <label htmlFor="state">Location</label> <br></br>
          <select name="state" id="state" className="form-select form-select-sm" 
          aria-label="Default select example" value={filters.state}
          onChange={handleFilterChange}>
            <option value="all">All</option>
            {malaysiaStates.map((state, index) => (
          <option key={index} value={state}>
            {state}
          </option>
        ))}
          </select>
        </div>
        <div>
        <label htmlFor="age">Age</label> <br></br>
          <select name="age" id="age" className="form-select form-select-sm" 
          aria-label="Default select example" value={filters.age}
          onChange={handleFilterChange}>
          <option value="all">All</option>
            <option value="Baby">Baby</option>
            <option value="Young">Young</option>
            <option value="Adult">Adult</option>
            <option value="Senior">Senior</option>
          </select>
        </div>
        <div>
        <label htmlFor="size">Size</label> <br></br>
          <select name="size" id="size" className="form-select form-select-sm" 
          aria-label="Default select example" value={filters.size}
          onChange={handleFilterChange}>
            <option value="all">All</option>
            <option value="Small">Small</option>
            <option value="Medium">Medium</option>
            <option value="Large">Large</option>
          </select>
        </div>
        <div>
        <label>Gender</label> <br></br>
          <select name="gender" id="gender" className="form-select form-select-sm" 
          aria-label="Default select example" value={filters.gender}
          onChange={handleFilterChange}>
            <option value="all">All</option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
          </select>
        </div>
        <div className="clearBtnContainer">
        {(filters.petType!=="all"||filters.state!=="all"||filters.age!=="all"||filters.size!=="all"||filters.gender!=="all")
        &&<button onClick={handleClearFilters} className="clearFilterBtn">
          Clear
        </button>}
      </div>
       </div>
       <button type="button" data-coreui-toggle="collapse" data-coreui-target="collapseExample"  onClick={handleButtonClick}
        aria-expanded={isExpanded} aria-controls="collapseExample" style={{ alignItems: "flex-end", justifySelf:'right', padding: "5px 20px", background:"none", border: "none", marginLeft:"auto"}}>
         {isExpanded?<FilterAltOffOutlinedIcon fontSize="large" style={{ marginRight: "5px" }}/>
            :<FilterAltOutlinedIcon fontSize="large" style={{ marginRight: "5px" }} />}Filter
      </button>
      </div>


      <div className="container-fluid">
        <div className="row row-cols-2 row-cols-md-4 g-4 p-4">
          
          {currentPets.length!==0? currentPets.map((pet)=>(
            <div className="col" key={pet.id}>
            <div className="card h-60 p-0 m-0"  onClick={()=> navigate(`/pet-details/${pet.id}`)}>
              <div className="aspect-ratio-square">
              
              {/* <img src={"" }  */}
                <img src={ imageUrls[pet.id]||"/blue.gif" } 
                className="card-img-top" alt="..." />
              </div>
              <div className="card-body">
                <h5 className="card-page-title">{pet.petName}</h5>
                <p className="card-page-text">{pet.location}</p>
              {/* <button onClick={()=> navigate(`/pet-details/${pet.id}`)}>View</button>   */}
              </div>
            </div>
          </div>
          )):
          (pets.length!==0&&<p style={{marginTop: "70px", width:"100%"}}>No results matching your criteria.</p>)}
        </div>
      </div>
      <Box sx={{ height: 60, maxWidth: 400, width: '100%', p: 2, margin: "10px"}}>
                <MobileStepper
                    sx={{ backgroundColor:"#F8F8F8 !important" }}
                    variant="text"
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    nextButton={
                        <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1|| maxSteps === 0}>
                            Next <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                            <KeyboardArrowLeft /> Back
                        </Button>
                    }
                />
            </Box>
    </div>
  );
};

export default AdoptPet;